import { render, staticRenderFns } from "./SidebarNavList.vue?vue&type=template&id=4f2796e4"
import script from "./SidebarNavList.vue?vue&type=script&lang=js"
export * from "./SidebarNavList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports